import React, { Component } from "react";
import copy from "../assets/copy.svg";
import { connect } from "react-redux";
import BackArrow from "../common/BackArrow";

const mapStateToProps = (state) => ({
  userProfile: state.userProfile,
  business: state.business,
});

export default connect(mapStateToProps)(
  class Onboarding extends Component {
    state = {};
    link = React.createRef();
    render() {
      const raw_link = `${
        window.location.hostname === "localhost" ? "http" : "https"
      }://${window.location.host}/business/signup?invite_code=${
        this.props.business?.invitation_code
      }`;
      const link_message = `${String.capitalize(
        this.props.userProfile.first_name
      )} is inviting you to their Kindlybook Business account 🗃. \nKindlybook helps you manage bookings easily! Use this link to register \n \n${raw_link}`;

      const link = (
        <>
          {String.capitalize(this.props.userProfile.first_name)} is inviting you
          to their Kindlybook Business account. Kindlybook helps you manage bookings
          easily!
          <br />
          <br />
          Use this link to register <span className="link">{raw_link}</span>
        </>
      );
      const code = this.props.business?.invitation_code;

      return (
        <div className="onboarding-page form-container app-setting">
          <h1 className="form-title dsk">Invite team members</h1>

          <div className="form_step form-page">
            <div className="form-title mbl flex center">
              <BackArrow />
              Invite team members
            </div>
            <div
              className="form-container"
              style={{ background: "transparent", maxWidth: "500px" }}
            >
              {/* <div className="input-rapper">
              <p className="label">Your invite code</p>
              <div className="field colored flex space-btw">
                {code}
                <button
                  className="cpy co-pink px-14 flex center"
                  data-clipboard-text={code}
                  onClick={window.copiedLink}
                >
                  <img src={copy} alt="" srcset="" /> Copy Code
                </button>
              </div>
            </div> */}
{/* 
              <div className="input-rapper">
                <p className="label">Your invite code</p>
                <div className="field co-black w-900">
                  {code}
                  <div className="footer">
                    <button
                      className="co-pink copy-btn"
                      data-clipboard-text={code}
                      onClick={window.copiedLink}
                    >
                      <img src={copy} alt="" srcset="" /> Copy Code
                    </button>
                  </div>
                </div>
              </div> */}

              <div className="input-rapper">
                <p className="label">Copy your invite link and message</p>
                <div className="field" id="invite_link">
                  {link}
                  <div className="footer">
                    <button
                      className="co-pink copy-btn"
                      data-clipboard-text={link_message}
                      onClick={window.copiedLink}
                    >
                      <img src={copy} alt="" srcset="" /> Copy Link and Message
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex center space-btw"></div>
            </div>
          </div>
        </div>
      );
    }
  }
);
